export default Object.freeze({
  reported: 1,
  approved: 2,
  denied: 3,
  invoiceAdjustment: 4,
});
